import { ArticlesApi } from '@services/api/articles'
import { useEffect, useState } from 'react'
import { Article } from 'types/article'

export interface Props {
  pagination?: {
    per?: number
    page?: number
  }
  editorial_slug?: string
  more_reads?: boolean
}
interface ParamsArticles {
  editorial_slug?: string
  more_reads?: boolean
}

export const UseMoreReadArticles = (
  params: Props = {
    pagination: undefined,
    editorial_slug: undefined,
    more_reads: undefined
  }
): {
  moreReadArticles: Article[]
  findMoreReadArticles: (params: ParamsArticles) => void
} => {
  const [moreReadArticles, setMoreReadArticles] = useState<Article[]>()
  const { pagination, editorial_slug, more_reads } = params

  const removeUndefineValue = (obj: any): any => {
    Object.keys(obj).map(key => obj[key] === undefined && delete obj[key])
  }
  const findMoreReadArticles = (_params: ParamsArticles) => {
    const _paramsArticle = {
      ...(pagination || { per: 3, page: 1 }),
      ..._params
    }
    removeUndefineValue(_paramsArticle)
    ArticlesApi.index(_paramsArticle).then(({ data }) => {
      setMoreReadArticles(data.articles)
    })
  }
  useEffect(() => {
    ;(editorial_slug || more_reads) &&
      findMoreReadArticles({ editorial_slug, more_reads })
  }, [])

  return { moreReadArticles, findMoreReadArticles }
}
